if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();
      this.form = this.querySelector('form');
      this.variantIdInput.disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      this.submitButton = this.querySelector('[type="submit"]');
      this.submitButtonText = this.submitButton.querySelector('span');
      if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');
      this.hideErrors = this.dataset.hideErrors === 'true';
      this.giftWrapCheckbox = this.querySelector('[data-vk-gift-wrap]');
      this.giftWrapPriceOutput = this.querySelector('[data-vk-gift-wrap-price]');
      this.giftWrapPriceMap = this.readGiftWrapPriceMap();
      if (this.giftWrapCheckbox) {
        this.form.addEventListener('change', () => requestAnimationFrame(() => this.updateGiftWrapPrice()));
        this.giftWrapCheckbox.addEventListener('change', () => this.updateGiftWrapCheckoutState());
        this.updateGiftWrapPrice();
        this.updateGiftWrapCheckoutState();
      }
    }
    updateGiftWrapCheckoutState() {
      if (!this.giftWrapCheckbox) return;
      const giftWrapSelected = this.giftWrapCheckbox.checked;
      this.querySelectorAll('.shopify-payment-button, .shiprocket-headless').forEach((element) => element.toggleAttribute('hidden', giftWrapSelected));
      this.querySelector('[data-vk-gift-wrap-checkout-note]')?.toggleAttribute('hidden', !giftWrapSelected);
    }
    onSubmitHandler(evt) {
      evt.preventDefault();
      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;
      this.handleErrorMessage();
      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('loading');
      this.querySelector('.loading__spinner').classList.remove('hidden');
      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];
      const formData = new FormData(this.form);
      const giftWrapVariantId = this.getGiftWrapVariantId(formData.get('id'));
      if (this.cart) {
        formData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
        formData.append('sections_url', window.location.pathname);
        this.cart.setActiveElement(document.activeElement);
      }
      if (giftWrapVariantId) {
        const properties = {};
        formData.forEach((value, key) => {
          const match = key.match(/^properties\[(.+)\]$/);
          if (match && value !== '') properties[match[1]] = value;
        });
        const mainItem = { id: Number(formData.get('id')), quantity: parseInt(formData.get('quantity')) || 1 };
        if (Object.keys(properties).length) mainItem.properties = properties;
        if (formData.get('selling_plan')) mainItem.selling_plan = Number(formData.get('selling_plan'));
        const payload = { items: [mainItem, { id: Number(giftWrapVariantId), quantity: mainItem.quantity, properties: { 'Gift packing': 'Yes', _vk_gift_parent_variant: String(mainItem.id) } }] };
        if (this.cart) {
          payload.sections = this.cart.getSectionsToRender().map((section) => section.id);
          payload.sections_url = window.location.pathname;
        }
        config.headers['Content-Type'] = 'application/json';
        config.body = JSON.stringify(payload);
      } else config.body = formData;
      const variantId = formData.get('id');
      const quantity = parseInt(formData.get('quantity')) || 1;
      const linesUpdateDeferred = this.createCartLinesUpdateEvent(variantId, quantity);
      fetch(routes.cart_add_url, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            publish(PUB_SUB_EVENTS.cartError, { source: 'product-form', productVariantId: variantId, errors: response.errors || response.description, message: response.message });
            this.handleErrorMessage(response.description);
            this.dispatchCartErrorEvent(response.description || response.message, 'INVALID');
            linesUpdateDeferred?.reject(new Error(response.description || response.message));
            const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
            if (!soldOutMessage) return;
            this.submitButton.setAttribute('aria-disabled', true);
            this.submitButtonText.classList.add('hidden');
            soldOutMessage.classList.remove('hidden');
            this.error = true;
            return;
          } else if (!this.cart) {
            this.resolveCartLinesUpdate(linesUpdateDeferred);
            window.location = window.routes.cart_url;
            return;
          }
          this.resolveCartLinesUpdate(linesUpdateDeferred);
          const startMarker = CartPerformance.createStartingMarker('add:wait-for-subscribers');
          if (!this.error) publish(PUB_SUB_EVENTS.cartUpdate, { source: 'product-form', productVariantId: variantId, cartData: response }).then(() => CartPerformance.measureFromMarker('add:wait-for-subscribers', startMarker));
          this.error = false;
          const quickAddModal = this.closest('quick-add-modal');
          if (quickAddModal) {
            document.body.addEventListener('modalClosed', () => { setTimeout(() => { CartPerformance.measure('add:paint-updated-sections', () => this.cart.renderContents(response)); }); }, { once: true });
            quickAddModal.hide(true);
          } else CartPerformance.measure('add:paint-updated-sections', () => this.cart.renderContents(response));
        })
        .catch((e) => {
          console.error(e);
          this.dispatchCartErrorEvent(e.message || 'Network error', 'SERVICE_UNAVAILABLE');
          linesUpdateDeferred?.reject(e);
        })
        .finally(() => {
          this.submitButton.classList.remove('loading');
          if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
          if (!this.error) this.submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading__spinner').classList.add('hidden');
          CartPerformance.measureFromEvent('add:user-action', evt);
        });
    }
    handleErrorMessage(errorMessage = false) {
      if (this.hideErrors) return;
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');
      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);
      if (errorMessage) this.errorMessage.textContent = errorMessage;
    }
    toggleSubmitButton(disable = true, text) {
      if (disable) { this.submitButton.setAttribute('disabled', 'disabled'); if (text) this.submitButtonText.textContent = text; }
      else { this.submitButton.removeAttribute('disabled'); this.submitButtonText.textContent = window.variantStrings.addToCart; }
    }
    createCartLinesUpdateEvent(variantId, quantity) {
      const { CartLinesUpdateEvent } = window.StandardEvents || {};
      if (!CartLinesUpdateEvent) return null;
      const deferred = CartLinesUpdateEvent.createPromise();
      this.dispatchEvent(new CartLinesUpdateEvent({ action: 'add', context: 'product', lines: [{ merchandiseId: variantId, quantity }], promise: deferred.promise }));
      return deferred;
    }
    resolveCartLinesUpdate(deferred) {
      if (!deferred) return;
      const { CartLinesUpdateEvent } = window.StandardEvents || {};
      if (!CartLinesUpdateEvent) return;
      const pendingCartDataPromise = typeof CartItems !== 'undefined' ? CartItems.fetchCartData() : fetch(routes.cart_url + '.json').then((response) => response.json());
      pendingCartDataPromise.then((cart) => { if (!cart?.currency) return deferred.reject(new Error('Missing currency in cart response')); deferred.resolve({ cart: CartLinesUpdateEvent.createCartFromAjaxResponse(cart) }); }).catch((e) => deferred.reject(e));
    }
    dispatchCartErrorEvent(message, code) {
      const { CartErrorEvent } = window.StandardEvents || {};
      if (!CartErrorEvent) return;
      this.dispatchEvent(new CartErrorEvent({ error: message, code }));
    }
    readGiftWrapPriceMap() {
      const data = this.querySelector('[data-vk-gift-product-prices]');
      if (!data) return {};
      try { return JSON.parse(data.textContent); } catch (error) { console.error('Unable to read gift-packing prices', error); return {}; }
    }
    getGiftWrapDetails(productVariantId) {
      if (!this.giftWrapCheckbox) return null;
      const price = Number(this.giftWrapPriceMap[String(productVariantId)] || 0);
      if (price <= 50000) return { id: this.giftWrapCheckbox.dataset.basicVariant, price: 6000 };
      if (price <= 99900) return { id: this.giftWrapCheckbox.dataset.plusVariant, price: 9900 };
      if (price <= 199900) return { id: this.giftWrapCheckbox.dataset.premiumVariant, price: 19900 };
      if (price <= 499900) return { id: this.giftWrapCheckbox.dataset.signatureVariant, price: 39900 };
      return { id: this.giftWrapCheckbox.dataset.luxeVariant, price: 79900 };
    }
    getGiftWrapVariantId(productVariantId) { if (!this.giftWrapCheckbox?.checked) return null; return this.getGiftWrapDetails(productVariantId)?.id || null; }
    updateGiftWrapPrice() {
      if (!this.giftWrapCheckbox || !this.giftWrapPriceOutput) return;
      const details = this.getGiftWrapDetails(this.variantIdInput?.value);
      if (!details) return;
      const amount = new Intl.NumberFormat('en-IN', { style: 'currency', currency: 'INR', maximumFractionDigits: 0 }).format(details.price / 100);
      this.giftWrapPriceOutput.textContent = 'Add gift packing (+' + amount + ')';
    }
    get variantIdInput() { return this.form.querySelector('[name=id]'); }
  });
}
